import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const UnichainLogoCircle = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let square;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      square,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = square;
    $[4] = t1;
  } else {
    className = $[1];
    rest = $[2];
    square = $[3];
    t1 = $[4];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[5] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[5] = size;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs><radialGradient cx="50%" cy="50%" fx="50%" fy="50%" id="unichain-logo-circle-gradient" r="50%"><stop offset="0%" stopColor="#FC74FE" /><stop offset="100%" stopColor="#F50DB4" /></radialGradient></defs>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = square ? 0 : 12;
  let t5;
  if ($[8] !== t4) {
    t5 = <rect fill="url(#unichain-logo-circle-gradient)" height={24} rx={t4} width={24} />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M20.4 11.84a8.24 8.24 0 0 1-8.24-8.24h-.32v8.24H3.6v.32a8.24 8.24 0 0 1 8.24 8.24h.32v-8.24h8.24v-.32Z" fill="#FFF" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = <g fill="none" fillRule="nonzero">{t5}{t6}</g>;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== className || $[14] !== rest || $[15] !== t2 || $[16] !== t7) {
    t8 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}{t7}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t2;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export const UnichainLogoCircleMonochrome = t0 => {
  const $ = _c(16);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== fill) {
    t4 = fillVariants({
      fill
    });
    $[6] = fill;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fillAttribute || $[9] !== t4) {
    t5 = <path className={t4} d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm.16 3.6h-.32v8.24H3.6v.32a8.24 8.24 0 0 1 8.24 8.24h.32v-8.24h8.24v-.32a8.24 8.24 0 0 1-8.24-8.24Z" fill={fillAttribute} fillRule="evenodd" />;
    $[8] = fillAttribute;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== className || $[12] !== rest || $[13] !== size || $[14] !== t5) {
    t6 = <svg className={className} height={size} viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg" {...rest}>{t5}</svg>;
    $[11] = className;
    $[12] = rest;
    $[13] = size;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};